module.exports = __webpack_public_path__ + "img/index-new-01.09f51244.svg";